<template>
	<v-row class="ma-0 pb-offset">
		<v-col class="pa-0 pb-4" cols="12">
			<v-card class="mb-2 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Mail automatiche</p>
                    <v-spacer></v-spacer>
                </v-card-title>				
				<v-divider></v-divider>
				<v-list three-line subheader class="background-2 pa-2">
					<v-list-item>
						<v-list-item-action>
							<v-checkbox color="primary" v-model="settings['enable_send_companyprivacy']"></v-checkbox>
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>Mail automatiche</v-list-item-title>
							<v-list-item-subtitle>Attiva l'invio automatico di email per il consenso sulla privacy
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
					<v-list-item class="pl-8" v-if="settings['enable_send_companyprivacy']">

						<v-list-item-content>
							<v-list-item-title class="pl-8 pb-4">Seleziona i tipi di azienda a cui inviare il modulo per il consenso della privacy</v-list-item-title>
							<v-row class="mx-0">
								<v-col class="pa-0 pl-8 px-4" cols="6">
									<v-select
										:items="items"
										label="Stato Azienda"
										v-validate="'required'"
										required="required"
										v-model="settings['companyprivacy_options']"
										multiple
										return-object
										:menu-props="{'offset-y': true}"
										clearable
										outlined
										small-chips
										dense>
									</v-select>
								</v-col>
							</v-row>
						</v-list-item-content>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text class="pa-2 mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>

		<v-col class="pa-0 pb-4" cols="12">
			<v-card class="mb-2 background-2 round-card">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3">Tracciamento email</p>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-divider></v-divider>
				<v-list three-line subheader class="background-2 pa-2">
					<v-list-item>
						<v-list-item-action>
							<v-checkbox color="primary" v-model="settings['email_tracking_disabled']"></v-checkbox>
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>Disattiva il tracciamento delle email</v-list-item-title>
							<v-list-item-subtitle>Nessun pixel di apertura e nessun click tracciato in tutte le email inviate da GiveMeHive, documenti e mail marketing. La riga sul tracciamento viene tolta in automatico dalle newsletter.</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
					<v-list-item v-if="!settings['email_tracking_disabled']">
						<v-list-item-action>
							<v-checkbox color="primary" v-model="settings['default_tracking_consent']"></v-checkbox>
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>Consenso al tracciamento predefinito</v-list-item-title>
							<v-list-item-subtitle>Valore iniziale del consenso al tracciamento (pixel di apertura e click nelle email) per nuove aziende, lead, fornitori e contatti. Le anagrafiche esistenti non cambiano.</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text class="pa-2 mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>

		<v-col class="pa-0 pt-0 pb-4" cols="12">
            <crud
            	modelDef="templates-companyprivacy"
			    action-icon="dynamic_feed"
			    title="Template"
				action-position='absolute'
            ></crud>
		</v-col>
	</v-row>
</template>
<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin';

	export default {
		name:'companies-privacy',
		mixins: [SettingsOptionsMixin],		
		data() {
			return {
				model: 'companyprivacy',
				settings: {
				    'enable_send_companyprivacy': false,
				    'companyprivacy_options': null,
				    'email_tracking_disabled': false,
				    'default_tracking_consent': false,
                },
                items: []
			}
        },
        
        created() {
            this.axios.post('generaltype', {'key': 'company_status'}).then(response => {
                this.items = response.data.general_type
                // this.pagination.totalItems = data.total
            }, response => {
                // error callback
                this.loading = false
            })
        }
	}
  </script>
